import { gql } from '@apollo/client';

export const PayrollQreFragment = gql`
  fragment PayrollQre on PayrollQre {
    id
    name
    email
    title
    department
    managerName
    hireDate
    terminationDate
    costCenter
    entity
    qualifiedAmountCents
    amountCents
    qreRdPercentage
    payrollProvider
    ticketingProviders
    state
    country
    rdCategory
    rdTaxCreditContributorId
    payrollExpenseId
    isOfficer
  }
`;
